import { Route, Routes } from 'react-router-dom';

import MainLayout from 'components/MainLayout';
import RouteProvider from 'components/RouteProvider';
import MyProject from 'pages/MyProject/MyProject';
import Account from 'pages/Account/Account';
import Preference from 'pages/Preference/Preference';
import Editor from 'pages/Editor/Editor';

const Router = () => {
  return (
    <Routes>
      <Route element={<RouteProvider />}>
        <Route element={<MainLayout />}>
          <Route path="/" element={<MyProject />} />
          <Route path="/setting/preference" element={<Preference />}></Route>
          <Route path="/setting/account" element={<Account />}></Route>
        </Route>
        <Route path="/:ownerName/:projectName" element={<Editor />}></Route>
      </Route>
    </Routes>
  );
};

export default Router;
